var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "col-md-12 flex flex-column mt-4 claim-data",
      class: _vm.$_can("claims.update") ? "active" : "",
      on: {
        mouseover: function($event) {
          _vm.active = true
        },
        mouseleave: function($event) {
          _vm.active = false
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        !_vm.editData
          ? _c("div", { staticClass: "col-md-10 claim-data-title" }, [
              _vm._v(_vm._s(_vm.claimById.title))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.editData
          ? _c("div", { staticClass: "col-md-10 claim-data-title" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.claim.title,
                    expression: "claim.title"
                  }
                ],
                staticClass: "edit-input w-full",
                attrs: { type: "text" },
                domProps: { value: _vm.claim.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.claim, "title", $event.target.value)
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.active && _vm.$_can("claims.update")
          ? _c(
              "div",
              {
                staticClass: "col-md-2 flex justify-content-end",
                on: { click: _vm.toggleEdit }
              },
              [_c("span", { staticClass: "fa fa-pencil pointer edit-icon" })]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "assignee-title" }, [
        _vm._v("Claim description")
      ]),
      _vm._v(" "),
      !_vm.editData
        ? _c(
            "span",
            { staticClass: "claim-data-description description-format" },
            [_vm._v("\n    " + _vm._s(_vm.claimById.description) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editData
        ? _c("span", { staticClass: "claim-data-description" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.claim.description,
                  expression: "claim.description"
                },
                { name: "auto-resize", rawName: "v-auto-resize" }
              ],
              staticClass: "edit-input w-full mt-1",
              attrs: { type: "text" },
              domProps: { value: _vm.claim.description },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.claim, "description", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "mt-1" }, [
              _vm.editData
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: _vm.buttonDisabled },
                      on: { click: _vm.claimUpdate }
                    },
                    [_vm._v("\n        Save\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editData
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: { click: _vm.toggleEdit }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31f94090", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f94090","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimDescription.vue
// module id = null
// module chunks = 